/// <amd-module name="SuiteCommerce.ShippingBar.Common.Cookies"/>
define("SuiteCommerce.ShippingBar.Common.Cookies", ["require", "exports", "jQuery"], function (require, exports, jQuery) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var Cookies = /** @class */ (function () {
        function Cookies() {
            try {
                Cookies.JSCookies = require('js.cookie');
            }
            catch (_a) { }
        }
        Cookies.getInstance = function () {
            if (!Cookies.instance) {
                Cookies.instance = new Cookies();
            }
            return Cookies.instance;
        };
        Cookies.prototype.get = function (name) {
            if (Cookies.JSCookies) {
                return Cookies.JSCookies.get(name);
            }
            return jQuery.cookie(name);
        };
        Cookies.prototype.getAll = function () {
            if (Cookies.JSCookies) {
                return Cookies.JSCookies.get();
            }
            return jQuery.cookie();
        };
        Cookies.prototype.set = function (name, value) {
            if (Cookies.JSCookies) {
                Cookies.JSCookies.set(name, value);
            }
            else {
                jQuery.cookie(name, value);
            }
        };
        Cookies.prototype.remove = function (name) {
            if (Cookies.JSCookies) {
                Cookies.JSCookies.remove(name);
            }
            else {
                jQuery.cookie(name, null);
            }
        };
        return Cookies;
    }());
    exports.default = Cookies;
});
